"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Hn = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 1260 630", ...props },
    react_1.default.createElement("path", { fill: "#0d3b99", d: "M1260 0H0v630h1260z" }),
    react_1.default.createElement("path", { fill: "#fff", d: "M1260 210H0v210h1260z" }),
    react_1.default.createElement("path", { id: "hn_svg__a", fill: "#0d3b99", d: "m630 280 20.572 63.315-53.859-39.131h66.573l-53.859 39.131z" }),
    react_1.default.createElement("g", { id: "hn_svg__b" },
        react_1.default.createElement("use", { xlinkHref: "#hn_svg__a", transform: "translate(-175 -52.465)" }),
        react_1.default.createElement("use", { xlinkHref: "#hn_svg__a", transform: "translate(-175 52.534)" })),
    react_1.default.createElement("use", { xlinkHref: "#hn_svg__b", transform: "translate(350)" })));
exports.default = Hn;
//# sourceMappingURL=Hn.js.map